import React, { useState, type ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export interface FaqItem {
  question: string;
  answer: string | ReactNode;
}
interface FaqAccordionProps {
  items: FaqItem[];
}
export function FaqAccordion({
  items
}: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full" data-id="element-66">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className="border-b border-seaglass/20 last:border-0" data-id="element-67">
            <button onClick={() => toggleItem(index)} className="w-full flex items-center justify-between py-5 text-left focus:outline-none group" aria-expanded={isOpen} data-id="element-68">
              <span className="text-lg font-semibold text-navy group-hover:text-navy/80 transition-colors duration-200 pr-8" data-id="element-69">
                {item.question}
              </span>
              <motion.div animate={{
            rotate: isOpen ? 180 : 0
          }} transition={{
            duration: 0.2,
            ease: 'easeInOut'
          }} className="flex-shrink-0 text-seaglass" data-id="element-70">
                <ChevronDown className="w-5 h-5" data-id="element-71" />
              </motion.div>
            </button>
            <AnimatePresence initial={false} data-id="element-72">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: [0.22, 1, 0.36, 1]
          }} className="overflow-hidden" data-id="element-73">
                  <div className="pb-6 text-body text-text" data-id="element-74">{item.answer}</div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}